import type { DataTableColumn } from "@etudescarre/ui";
import { FilePdf as FilePdfIcon } from "@phosphor-icons/react";
import { useEffect } from "react";
import { useParams } from "react-router";
import { apiClient } from "@/lib/api/client";
import { formatDay } from "@/lib/utils/date";
import { Classeur, type FilterDef } from "../components/classeur";
import {
  useClasseurFilters,
  useClasseurState,
} from "../components/classeur/use-classeur-data";

type ReportResponseItem = {
  id: string;
  dateReponse: string | null;
  reportCount: number;
  hasPdf: boolean;
};

const columns: DataTableColumn<ReportResponseItem>[] = [
  { id: "id", header: "N°", accessor: "id" },
  {
    id: "dateReponse",
    header: "Date reponse",
    accessor: "dateReponse",
    cell: ({ value }) => (value ? formatDay(value as string) : "-"),
  },
  { id: "reportCount", header: "Rapports concernes", accessor: "reportCount" },
  {
    id: "pdf",
    header: "PDF",
    accessor: "hasPdf",
    cell: ({ value }) =>
      value ? (
        <FilePdfIcon size={18} className="text-red-600" />
      ) : (
        <span className="text-zinc-300">-</span>
      ),
  },
];

const filters: FilterDef[] = [];

export function ClasseurReponsesRapports() {
  const { yardId } = useParams<{ yardId: string }>();
  const { activeFilters, onFilterChange } = useClasseurFilters({ filters });
  const [state, setState] = useClasseurState<ReportResponseItem>();

  useEffect(() => {
    async function fetchData() {
      setState((prev) => ({ ...prev, isLoading: true }));
      const { data } = await apiClient.GET(
        "/api/yards/{yardId}/report-responses",
        {
          params: { path: { yardId: yardId ?? "" } },
        },
      );
      if (data) {
        const items = data.data.items.map((item) => ({
          ...item,
          id: String(item.id),
        }));
        setState({ items, total: data.data.total, isLoading: false });
      } else {
        setState({ items: [], total: 0, isLoading: false });
      }
    }
    fetchData();
  }, [yardId, setState]);

  return (
    <Classeur
      title="Classeur réponses à rapports"
      items={state.items}
      columns={columns}
      filters={filters}
      activeFilters={activeFilters}
      onFilterChange={onFilterChange}
      isLoading={state.isLoading}
      emptyMessage="Aucune reponse a rapport"
      total={state.total}
    />
  );
}
